import styled, { css } from 'styled-components'
import { Dialog, colors, Paragraph, OptionGroupStyled } from '@microfrontends/react-components'
import { EDevice } from '../../../../store'

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const SectionContent = styled.div``
export const SwitcherBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 16px 0;
`
export const TitleBox = styled.div`
    width: 75%;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #333;
    padding-right: 0;
`
export const StyledSwitcher = styled.div`
    width: 25%;
    display: inline-flex;
    justify-content: flex-end;
    padding-left: 0;
    height: 28px;

    label {
        margin-left: 0;
    }
`
export const SearchableBox = styled.div<{ isMobile?: boolean }>`
    margin-top: 16px;
    background-color: ${(props) => (props.isMobile ? colors.neutral[95] : colors.primary[99])};
    padding: 16px 12px;
    border-radius: 12px;
    display: flex;
    flex-flow: column;
    gap: 16px;
`
export const SearchableItem = styled.div<{ isEnable?: boolean }>`
    cursor: ${({ isEnable }) => (isEnable ? 'pointer' : 'normal')};
    background-color: ${colors.grey[99]};
    border: 1px solid ${colors.grey[90]};
    border-radius: 6px;
    display: flex;
    margin: 0 0 8px 0;
    font-weight: 400;
    padding: 8px 12px;
    :hover {
        ${({ isEnable }) =>
            isEnable &&
            css`
                background: ${colors.primary[95]};
                border: 1px solid ${colors.primary[80]};
            `}
    }
    &.active {
        border: 1px solid ${colors.primary[80]};
    }
`
export const Left = styled.div`
    display: inline-flex;
    padding-right: 10px;
    label {
        flex-direction: column;
        margin-top: 2px;
    }
`
export const Right = styled.div`
    display: block;
    width: 100%;
    label {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 0;
        color: ${colors.grey[20]};
        :hover {
            cursor: pointer;
        }
    }
    .btn-link {
        display: inline-flex;
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        color: ${colors.primary[40]};
        align-content: center;
        align-items: center;
    }
`
export const ResumeDesc = styled.div<{ isMobile?: boolean }>`
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    & > div {
        display: flex;
        align-items: center;
        span {
            display: flex;
            color: ${colors.grey[30]};
            margin-left: 5px;
            p {
                max-width: 200px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                margin: 0;
                ${({ isMobile }) =>
                    isMobile &&
                    css`
                        max-width: 100px;
                    `}
            }
        }
    }
    span {
        cursor: pointer;
    }
`

export const OnboardingBox = styled.div`
    a:first-child {
        margin-right: 20px;
    }
    .btn-link {
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        color: #005aff;
        align-content: center;
        align-items: center;
    }
`
export const StyledDialog = styled(Dialog)`
    z-index: 1009;
    div[class^='Dialog-module_body_'] {
        background-color: #fbfbfb;
        padding-left: 0px;
        padding-right: 0px;
    }
    .text-h2 {
        width: 100%;
        text-align: center;
    }
    span[class^='Dialog-module_icon__'] {
        position: absolute;
        left: 16px;
    }
`

export const VisibleOnLargeScreen = styled.div`
    display: none;
    @media screen and (min-width: 1200px) {
        display: block;
    }
`
export const HiddenOnLargeScreen = styled.div`
    display: block;
    @media screen and (min-width: 1200px) {
        display: none;
    }
`
export const AttachmentFileNameWrapper = styled.div<{ device: EDevice; fullWidth?: boolean }>`
    display: flex;
    width: calc(
        100% -
            ${({ device, fullWidth }) => {
                return fullWidth
                    ? 0
                    : {
                          [EDevice.DESKTOP]: 280,
                          [EDevice.LAPTOP]: 280,
                          [EDevice.TABLET]: 50,
                          [EDevice.MOBILE]: 50
                      }[device]
            }}px
    );
    span:first-child {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    span:last-child {
        flex: 1 0 auto;
    }
`
export const WrapSwitcherMobile = styled.div<{ notHaveCV?: boolean }>`
    background: #fff;
    border-radius: 6px;
    margin-bottom: 8px;
    label {
        margin-bottom: 0;
    }
    ${({ notHaveCV }) =>
        notHaveCV &&
        css`
            pointer-events: none;
        `}
`
export const AttachmentMobileWrapper = styled(WrapSwitcherMobile)`
    min-height: 700px;
    overflow: auto;
`
export const SearchableContainer = styled.div``
export const SearchableText = styled.div<{ isSearchable: boolean; isMobile: boolean }>`
    ${({ isSearchable }) =>
        !isSearchable &&
        css`
            color: #969696;
            max-width: unset;
        `}
    ${({ isMobile }) =>
        isMobile &&
        css`
            margin-bottom: 0;
        `}
`
export const RefreshStatus = styled.div`
    flex: 1;
    color: rgb(51 51 51 / 70%);
`
export const WrapSwitcher = styled.div<{ isMobile: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    gap: 16px;

    ${({ isMobile }) =>
        isMobile &&
        css`
            margin-top: 12px;
            gap: unset;
            button.disable {
                color: #e5e5e5;
                border-color: #e5e5e5;
                pointer-events: none;
            }
        `}
`

export const WarningSearchableModal = styled.div`
    font-size: 15px;
`

export const Description = styled(Paragraph)`
    margin-top: 16px;
    font-size: 14px;
`
export const RightButtonWrapper = styled.div<{
    active?: boolean
}>`
    position: absolute;
    top: 12px;
    right: 12px;
    display: ${(props) => (props.active ? 'flex' : 'none')};
    align-items: center;
    gap: 10px;

    ${OptionGroupStyled.Wrapper}:hover & {
        display: flex;
    }
`
